export default {
	title: 'Risques / Ouvertures',
	risks: 'Risques',
	opportunities: 'Ouvertures',
	url: 'risques',
	subtitle: '',
	all_categories: 'Filtre catégories',
	all_impacts: "Filtre d'impact",
	all_likelihoods: 'Filtre probabilité',
	all_stakeholders: 'Filtre parties prenantes',
	all_stakes: 'Filtre enjeux',
	no_stakeholder: 'Aucune partie prenante',
	tabs: {
		filters: {
			title: 'Filtres',

			displayed_columns: 'Colonnes affichées',
			visualization_options: 'Options de visualisation'
		},
		options: {
			title: 'Affichage',
			are_links_visible: 'Afficher tous les liens',
			show_description: 'Afficher la description',
			chart_visible_stakes: 'Afficher les enjeux',
			chart_visible_stakeholders: 'Afficher les parties prenantes',
			chart_visible_risks: 'Afficher les risques',
			chart_visible_opportunities: 'Afficher les ouvertures'
		},
		general: {
			title: 'Général'
		},
		stakeholders: {
			title: 'Parties prenantes'
		},
		export: {
			title: 'Exporter'
		},
		comments: {
			title: 'Historique'
		}
	},
	visualization_tab: 'Visualisation',
	onboarding: {
		risks: {
			title: 'Revue des risques',
			description:
				"Voici les risques qui pèsent sur vos enjeux. Évaluez leur probabilité et leur impact, et corrigez ceux qui vous semblent mal calibrés."
		},
		opportunities: {
			title: 'Revue des ouvertures',
			description:
				"À l'inverse des risques, les ouvertures sont des dynamiques qui peuvent renforcer vos enjeux. Conservez celles qui sont actionnables, écartez le reste."
		}
	}
};
